import { List } from 'immutable';

import { type IListOf } from 'src/types';

import { ApiActions } from '../constants/ApiActions';
import { BrowseGenresKeys } from '../constants/BrowseGenres';
import { Map } from '../lib/ImmutableUtils';
import { createReducer } from '../lib/ReducerUtils';

const INITIAL_STATE = Map({
  [BrowseGenresKeys.GENRE_CATEGORIES_HAVE_LOADED]: false,
  [BrowseGenresKeys.GENRE_CATEGORY_TOKENS]: List() as IListOf<$TSFixMe>,
  [BrowseGenresKeys.GENRE_CATEGORY_TOKENS_TO_GENRE_IDS]: Map<$TSFixMe>(),
});
export type BrowseGenresState = typeof INITIAL_STATE;

// BROWSEGENRES REDUCER
export default createReducer(INITIAL_STATE, {
  [ApiActions.FETCH_GENRE_CATEGORIES_SUCCESS]: fetchGenreCategoriesSuccess,
  [ApiActions.FETCH_GENRES_BY_CATEGORY_ID_SUCCESS]: fetchGenresByCategoryIdSuccess,
});

// CASE FUNCTIONS

function fetchGenreCategoriesSuccess(
  state: BrowseGenresState,
  action: $TSFixMe,
): BrowseGenresState {
  return state.merge({
    [BrowseGenresKeys.GENRE_CATEGORIES_HAVE_LOADED]: true,
    [BrowseGenresKeys.GENRE_CATEGORY_TOKENS]: List(action.response.result.categories),
  });
}

function fetchGenresByCategoryIdSuccess(
  state: BrowseGenresState,
  action: $TSFixMe,
): BrowseGenresState {
  const categoryToGenresMap = state.get(BrowseGenresKeys.GENRE_CATEGORY_TOKENS_TO_GENRE_IDS);
  const newCategoryToGenresMap = categoryToGenresMap.set(
    (action.params as unknown as $TSFixMe)?.categoryToken,
    List(action.response.result.genres),
  );

  return state.set(BrowseGenresKeys.GENRE_CATEGORY_TOKENS_TO_GENRE_IDS, newCategoryToGenresMap);
}
